export default __webpack_public_path__ + "static/master-e3da462b4587899cb02a0a251e0e11fd.jpg";